import type { DocumentoExportable } from "@/componentes/exportar/modelo"
import { hoyLocal } from "@/lib/fechas"

import type { Filtros } from "./FiltrosTareas"
import { diasDeVida, type Tarea, TIPOS } from "./TarjetaTarea"

/**
 * Las tareas cargadas en el tablero o en la lista, como documento exportable.
 *
 * ⚠ **Se arma con las filas de la pantalla y no leyendo la tabla**: el tablero son
 * tarjetas, y en la lista el título es un botón (que `desdeTabla` salta). Así las dos
 * vistas exportan lo mismo, con el vencimiento como fecha y la edad como número.
 */

const ETIQUETA_TIPO = new Map(TIPOS.map((t) => [t.valor, t.etiqueta]))

/** Lo que dice QUÉ se está viendo: los filtros puestos, en palabras. */
export function subtituloDeTareas(
  f: Filtros,
  total: number | undefined,
  cargadas: number,
  nombreDe: (id: number | null) => string | undefined,
): string {
  const partes = [
    f.soloMias ? "Sólo las mías" : null,
    f.asignadoA !== null ? `De ${nombreDe(f.asignadoA) ?? `usuario ${f.asignadoA}`}` : null,
    f.sinAsignar ? "Sin asignar" : null,
    f.soloAbiertas ? "Sólo abiertas" : null,
    f.tipo ? `Tipo: ${ETIQUETA_TIPO.get(f.tipo) ?? f.tipo}` : null,
    f.buscar.trim() ? `Búsqueda: «${f.buscar.trim()}»` : null,
    total !== undefined ? `${cargadas} de ${total}` : null,
  ]
  return partes.filter(Boolean).join(" · ") || "Todas las tareas"
}

export function documentoDeTareas(
  tareas: Tarea[],
  nombreDe: (id: number | null) => string | undefined,
  subtitulo: string,
): DocumentoExportable {
  const hoy = hoyLocal()
  return {
    titulo: "Tareas",
    subtitulo,
    secciones: [
      {
        titulo: "Tareas",
        columnas: [
          { titulo: "Código", tipo: "texto" },
          { titulo: "Título", tipo: "texto" },
          { titulo: "Tipo", tipo: "texto" },
          { titulo: "Prioridad", tipo: "texto" },
          { titulo: "Responsable", tipo: "texto" },
          { titulo: "Vence", tipo: "fecha" },
          { titulo: "Vencida", tipo: "texto" },
          { titulo: "Edad (días)", tipo: "numero" },
          { titulo: "Estado", tipo: "texto" },
        ],
        filas: tareas.map((t) => {
          const vencida = t.vence_en !== null && t.cerrado_en === null && t.vence_en < hoy
          return {
            celdas: [
              t.codigo,
              t.titulo,
              ETIQUETA_TIPO.get(t.tipo) ?? t.tipo,
              t.prioridad,
              t.asignado_a === null ? "Sin asignar" : (nombreDe(t.asignado_a) ?? null),
              t.vence_en ? t.vence_en.slice(0, 10) : null,
              vencida ? "Sí" : null,
              t.cerrado_en === null ? diasDeVida(t) : null,
              t.estado.replaceAll("_", " "),
            ],
          }
        }),
      },
    ],
  }
}
